import React from 'react';
import parse from 'html-react-parser';

import classNames from 'classnames';
import { resolveSetting } from '../../../utils/settingsHelper';

export const getTextStyle = (props, settings) => {
	const {
		fontSize,
		textAlign,
		fontWeight,
		color,
		color2,
		shadow,
		display,
		useHeadingFontFamily,
	} = props;

	return {
		width: 'auto',
		color: resolveSetting(color2, settings) ? 'transparent' : resolveSetting(color, settings),
		...(resolveSetting(color2, settings) ? {
			background: `-webkit-linear-gradient(left, ${resolveSetting(color, settings)}, ${resolveSetting(color2, settings)}) text`,
		} : {}),
		...(resolveSetting(color2, settings) ? { WebkitBackgroundClip: 'text' } : {}),
		...(resolveSetting(color2, settings) ? { WebkitTextClip: 'background !important' } : {}),
		fontSize: `${resolveSetting(fontSize, settings)}px`,
		textShadow: `0px 0px 2px rgba(0,0,0,${(shadow || 0) / 100})`,
		fontWeight,
		textAlign,
		whiteSpace: 'pre-wrap',
		fontFamily: useHeadingFontFamily && settings.headingFontFamily ? settings.headingFontFamily : undefined,
		display,
	};
};

export function Text({
	settings,
	className,
	text,
	tag = 'p',
	...props
}) {
	const count = (text.match(/<p>/g) || []).length;

	const finalText = count > 1 ? text : text.replace('<p>', '<span>').replace('</p>', '</span>');

	const Tag = count > 1 || ['ul', 'li', 'div', 'p'].some((i) => finalText.includes(`<${i}>`)) ? 'div' : tag;

	return (
		<Tag
			className={classNames('ck-content', className)}
			style={getTextStyle(props, settings)}
		>
			{parse(count > 1 ? text : text.replace('<p>', '<span>').replace('</p>', '</span>'))}
		</Tag>
	);
}
